{
    "webshop_offer_voucher_correctCode": "輸入的代碼正確",
    "webShop_howToFindId_desc": "你可以在你的玩家個人資料中找到並複製你的個人 ID。",
    "webShop_howToFindId_link": "在哪裡找到我的個人 ID？",
    "webshop_offer_voucher_codeIsIncorrect": "代碼不正確",
    "webshop_offer_voucher_enterYourCode": "輸入你的個人 ID",
    "webShop_unexpectedError_desc": "發生未預期的錯誤，請稍後再試。",
    "webShop_accountBanned_desc": "帳號已被禁用！",
    "webshop_confirm": "好",
    "webshop_termsConditions_1": "服務條款",
    "webshop_purchase_privacyPolicy": "隱私政策",
    "webshop_legal_1": "合法",
    "webshop_support_1": "技術支援",
    "mbs_access_welcome_desc": "歡迎，{0}",
    "btn_login": "登入",
    "mbs_access_error_sessionExpired_desc": "你的輸入階段已經逾時。請手動輸入你的帳號 ID。"
}
